import {put, takeLatest} from 'redux-saga/effects';
import axios from 'axios';

import * as AuthActionType from '../../core/constants/ActionTypes';
import {getBaseUrl} from '../../core/utility/filter.utility';
import appConfig from '../../data/login.env';

export function* loginSaga(reqObj) {
    try {
        const res = yield axios.post(
            `${getBaseUrl()}/${appConfig.serviceEndPoints.login}`,
            {...reqObj.payload}
        );
        if (res && res.data) {
            localStorage.setItem('jwtToken', res.data.token);
            let authResult = res.data.res;
            const errArray = authResult.split('|');
            if (errArray[1]) {
                const loginErr = errArray[1];
                yield put({
                    type: AuthActionType.LOGIN_ERROR,
                    payload: {
                        loginErr
                    }
                });
            } else {
                if (authResult === 'CATCmaInAccessibleLinkPage') {
                    const zonesRes = yield axios.post(
                        `${getBaseUrl()}/${appConfig.serviceEndPoints.zones}`
                    );
                    if (zonesRes && zonesRes.data) {
                        const zones = zonesRes.data.res;
                        if (zones.defLogIn === 2) {
                            authResult = 'errorLink';
                        }
                    }
                } else if (authResult === 'downloadCourseDocumentsPage') {
                    const zonesRes = yield axios.post(
                        `${getBaseUrl()}/${appConfig.serviceEndPoints.zones}`
                    );
                    if (zonesRes && zonesRes.data) {
                        const zones = zonesRes.data;
                        if (zones.defLogIn === 2) {
                            authResult = 'pdfDownload';
                        }
                    }
                }

                yield put({
                    type: AuthActionType.LOGIN_SUCCESS,
                    payload: {
                        loginSuccess: authResult
                    }
                });
            }
        }
    } catch (error) {
        yield put({
            type: AuthActionType.LOGIN_ERROR,
            payload: {
                loginErr: 'Technical difficulty. Please try later.'
            }
        });
    }
}

export function* validateVoucherUidSaga(reqObj) {
    try {
        const res = yield axios.post(
            `${getBaseUrl()}/${appConfig.serviceEndPoints.validateVoucherUid}`,
            {...reqObj.payload}
        );
        if (res && res.data) {
            const authResult = res.data;
            if (authResult !== 'validUUID') {
                yield put({
                    type: AuthActionType.VOUCHER_ERROR,
                    payload: {
                        voucherErr: authResult
                    }
                });
            } else {
                yield put({
                    type: AuthActionType.VOUCHER_SUCCESS,
                    payload: {
                        voucherSuccess: authResult
                    }
                });
            }
        }
    } catch (error) {
        yield put({
            type: AuthActionType.VOUCHER_ERROR,
            payload: {
                loginErr: 'Technical difficulty. Please try later.'
            }
        });
    }
}

export function* forgetPwdSaga(reqObj) {
    try {
        const res = yield axios.post(
            `${getBaseUrl()}/${appConfig.serviceEndPoints.forgotPass}`,
            {...reqObj.payload}
        );

        if (res && res.data) {
            const result = res.data;
            const splitted = result.split('|');
            if (splitted[0] && splitted[0] === 'success') {
                yield put({
                    type: AuthActionType.FORGOT_SUCCESS,
                    payload: {
                        forgetSuccess: splitted[1]
                    }
                });
            } else {
                yield put({
                    type: AuthActionType.FORGOT_ERROR,
                    payload: {
                        forgetError: result
                    }
                });
            }
        }
    } catch (error) {
        yield put({
            type: AuthActionType.FORGET_ERROR,
            payload: {
                loginErr: 'Technical difficulty. Please try later.'
            }
        });
    }
}

export function* authWatcherSaga() {
    yield takeLatest(AuthActionType.LOGIN_ATTEMPT, loginSaga);
    yield takeLatest(AuthActionType.VALIDATE_VOUCHER, validateVoucherUidSaga);
    yield takeLatest(AuthActionType.FORGOT_PWD, forgetPwdSaga);
}
